import React, { useRef, useState } from 'react';
import ReCAPTCHA from 'react-google-recaptcha';
import './BrochureModal.css';

const API_BASE = process.env.REACT_APP_API_BASE_URL || 'https://api.mitadtu.in';
const RECAPTCHA_SITE_KEY = '6LcXD7wsAAAAAB67iijckOn9ia4lXA4UFuUvO1Qb';
const BROCHURE_PDF_URL = '/assets/MANET_Brochure_2025.pdf';

const validateEmail = (email) => /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
const validateMobile = (mobile) => /^[6-9]\d{9}$/.test(mobile);
const validateName = (name) => /^[a-zA-Z\s]{2,100}$/.test(name.trim());

const BrochureModal = ({ onClose }) => {
  const [form, setForm] = useState({ name: '', email: '', mobile: '' });
  const [submitting, setSubmitting] = useState(false);
  const [msg, setMsg] = useState({ type: '', text: '' });
  const [submitted, setSubmitted] = useState(false);
  const recaptchaRef = useRef(null);

  const handleChange = (e) => {
    setMsg({ type: '', text: '' });
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setMsg({ type: '', text: '' });

    if (!validateName(form.name)) {
      setMsg({ type: 'error', text: 'Enter a valid name (letters only, 2-100 characters).' });
      return;
    }
    if (!validateEmail(form.email)) {
      setMsg({ type: 'error', text: 'Enter a valid email address.' });
      return;
    }
    if (!validateMobile(form.mobile)) {
      setMsg({ type: 'error', text: 'Enter a valid 10-digit mobile number starting with 6-9.' });
      return;
    }

    const recaptchaToken = recaptchaRef.current?.getValue();
    if (!recaptchaToken) {
      setMsg({ type: 'error', text: "Please complete the \"I'm not a robot\" verification." });
      return;
    }

    setSubmitting(true);
    try {
      const res = await fetch(`${API_BASE}/api/brochure/submit-form`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ ...form, recaptchaToken }),
      });
      const data = await res.json();
      if (!res.ok) throw new Error(data.message);
      setSubmitted(true);
    } catch (err) {
      setMsg({ type: 'error', text: err.message || 'Submission failed. Please try again.' });
      recaptchaRef.current?.reset();
    } finally {
      setSubmitting(false);
    }
  };

  if (submitted) {
    return (
      <div className="brochure-overlay" onClick={onClose}>
        <div className="brochure-modal brochure-success-modal" onClick={(e) => e.stopPropagation()}>
          <button className="brochure-close" onClick={onClose}>✕</button>
          <div className="brochure-success-icon">✅</div>
          <h2 className="brochure-title">Thank You!</h2>
          <p className="brochure-subtitle">Your details have been submitted. Click below to view the brochure.</p>
          <a href={BROCHURE_PDF_URL} target="_blank" rel="noopener noreferrer" className="brochure-submit brochure-view-btn">
            📄 View Brochure
          </a>
          <button className="brochure-close-btn" onClick={onClose}>Close</button>
        </div>
      </div>
    );
  }

  return (
    <div className="brochure-overlay" onClick={onClose}>
      <div className="brochure-modal" onClick={(e) => e.stopPropagation()}>
        <button className="brochure-close" onClick={onClose}>✕</button>

        <h2 className="brochure-title">Welcome to MANET Pune</h2>
        <p className="brochure-subtitle">Please fill in your details to access the brochure.</p>

        {msg.text && <p className={`brochure-msg ${msg.type}`}>{msg.text}</p>}

        <form onSubmit={handleSubmit} className="brochure-form">
          <div className="brochure-field">
            <label>Full Name *</label>
            <input type="text" name="name" value={form.name} onChange={handleChange} placeholder="Enter your full name" required />
          </div>

          <div className="brochure-field">
            <label>Email Address *</label>
            <input type="email" name="email" value={form.email} onChange={handleChange} placeholder="Enter your email address" required />
          </div>

          <div className="brochure-field">
            <label>Mobile Number *</label>
            <input type="tel" name="mobile" value={form.mobile} onChange={handleChange} placeholder="10-digit mobile number" maxLength={10} required />
          </div>

          <div className="brochure-recaptcha">
            <ReCAPTCHA ref={recaptchaRef} sitekey={RECAPTCHA_SITE_KEY} />
          </div>

          <button type="submit" className="button" disabled={submitting}>
            {submitting ? 'Submitting...' : 'Submit'}
          </button>
        </form>
      </div>
    </div>
  );
};

export default BrochureModal;
